import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";

const AffidavitForm = (props) => {
  const { FormId, PatientId, PatientName, onFormSubmit, handleClose,PatientDob } =
    props;

  const [signatureDate, setSignatureDate] = useState(
    Moment().format("YYYY-MM-DD")
  );
    const [PatientDobs, setPatientDob] = useState(
    Moment(PatientDob).format("YYYY-MM-DD")
  );

  const fields = [
    "id",
    "patientId",
    "practiceId",
    "maskLeaks",
    "maskOrDeviceUncomfortable",
    "unableToSleepComfortably",
    "deviceNoiseDisturbs",
    "restrictsMovement",
    "notEffective",
    "strapsCauseDiscomfort",
    "pressureCausesToothProblems",
    "latexAllergy_CPAP",
    "claustrophobia_CPAP",
    "other_CPAP",
    "worriedMaskDiscomfort",
    "worriedRestriction",
    "latexAllergy_NoCPAP",
    "claustrophobia_NoCPAP",
    "frequentTravelCumbersome",
    "worriedDeviceNoise",
    "other_NoCPAP",
    "patientSignature",
    "signatureDate",
    "createdDate",
    "createdBy",
    "updatedDate",
    "updatedBy",
    "inactive",
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    practiceId: 0,
    maskLeaks: null,
    maskOrDeviceUncomfortable: null,
    unableToSleepComfortably: null,
    deviceNoiseDisturbs: null,
    restrictsMovement: null,
    notEffective: null,
    strapsCauseDiscomfort: null,
    pressureCausesToothProblems: null,
    latexAllergy_CPAP: null,
    claustrophobia_CPAP: null,
    other_CPAP: "",
    worriedMaskDiscomfort: null,
    worriedRestriction: null,
    latexAllergy_NoCPAP: null,
    claustrophobia_NoCPAP: null,
    frequentTravelCumbersome: null,
    worriedDeviceNoise: null,
    other_NoCPAP: "",
    patientSignature: "",
    signatureDate: "",
    createdDate: "",
    createdBy: "",
    updatedDate: "",
    updatedBy: "",
    inactive: false,
  };

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);

  // Load form data if editing
  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormAffidavitId?id=${FormId}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => {
            if (response[field] !== undefined) {
              setValue(field, response[field]);
            }
          });

          if (response.signatureDate) {
            setSignatureDate(Moment(response.signatureDate).format("YYYY-MM-DD"));
          }
        })
        .catch((error) => {
          console.error("Error loading form data:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load form data",
          });
        });
    }
  }, [FormId]);

  const onSubmit = (data) => {
    setSubmitting(true);

    const postData = {
      ...data,
      patientId: PatientId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormAffidavit`,
        postData,
        { headers }
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Form Added!",
          html: `<p>Affidavit for Intolerance to CPAP Device has been saved successfully.</p>`,
     timer: 2000, // 2 seconds
  showConfirmButton: false,
  timerProgressBar: true,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
        
        if (onFormSubmit) {
          onFormSubmit(response.id);
        }

        if (handleClose) {
          handleClose();
        }
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Failed!",
          html: `<p>${
            error.response?.data?.message ||
            "Something went wrong. Please try again."
          }</p>`,
          confirmButtonColor: "#F44336",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      });
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4,m:4 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Patient Information */}
         <Grid container spacing={3} >
                     <Grid item xs={12}>
                       <Typography
                         variant="h4"
                         align="center"
                         fontWeight="bold"
                         color="primary"
                         gutterBottom
                       >
                          AFFIDAVIT FOR INTOLERANCE TO CPAP DEVICE
                       </Typography>
                       
                     </Grid>
                   </Grid>
        <Grid container spacing={3} sx={{m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" fontWeight="medium" gutterBottom>
              Patient Name: {PatientName}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="signatureDate"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Patient's DOB"
                  type="date"
                  size="small"
                  fullWidth
                  variant="outlined"
                InputProps={{ readOnly: true }}
                  InputLabelProps={{ shrink: true }}
                  {...field}
                  value={PatientDobs || ""}
                 
                />
              )}
            />
          </Grid>
        </Grid>

        {/* CPAP Intolerance Reasons */}
        <Grid container spacing={3} sx={{m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
              I have attempted to use a CPAP device to manage my sleep-related breathing disorder and find it intolerable to use on a regular basis for the following reason(s):
            </Typography>
          </Grid>

          {/* CPAP Intolerance Checkboxes */}
          {[
            { name: "maskLeaks", label: "Mask Leaks" },
            { name: "maskOrDeviceUncomfortable", label: "Mask and/or device uncomfortable" },
            { name: "unableToSleepComfortably", label: "Unable to sleep comfortably" },
            { name: "deviceNoiseDisturbs", label: "Noise from the device disturbs me and/or my bed partner's sleep" },
            { name: "restrictsMovement", label: "Restricts movement during sleep" },
            { name: "notEffective", label: "Does not seem to be effective" },
            { name: "strapsCauseDiscomfort", label: "Straps/headgear cause discomfort" },
            { name: "pressureCausesToothProblems", label: "Pressure on upper lip causes tooth-related problems" },
            { name: "latexAllergy_CPAP", label: "Latex allergy" },
            { name: "claustrophobia_CPAP", label: "Claustrophobia" },
          ].map((item) => (
            <Grid item xs={12} key={item.name}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={field.value || false}
                      onClick={(e) => field.onChange(!field.value)}
                      style={{ marginRight: "10px", transform: "scale(1.2)" }}
                    />
                    <Typography variant="body1">{item.label}</Typography>
                  </label>
                )}
              />
            </Grid>
          ))}

          {/* Other CPAP Reason */}
          <Grid item xs={12}>
            <Controller
              name="other_CPAP"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Other (please specify)"
                  size="small"
                  fullWidth
                  variant="outlined"
                  {...field}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Preference for Oral Appliance */}
        <Grid container spacing={3} sx={{m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
              I have not attempted to use a CPAP device and would prefer to use an oral appliance for the following reason(s):
            </Typography>
          </Grid>

          {/* No CPAP Checkboxes */}
          {[
            { name: "worriedMaskDiscomfort", label: "I'm worried that the mask, straps/headgear will cause discomfort" },
            { name: "worriedRestriction", label: "I'm worried that the device will restrict movement during sleep" },
            { name: "latexAllergy_NoCPAP", label: "I have a latex allergy" },
            { name: "claustrophobia_NoCPAP", label: "I suffer from claustrophobia" },
            { name: "frequentTravelCumbersome", label: "I travel frequently and am worried that a CPAP device will be cumbersome to transport" },
            { name: "worriedDeviceNoise", label: "I'm worried that the noise from the device will disturb me and/or my bed partner's sleep" },
          ].map((item) => (
            <Grid item xs={12} key={item.name}>
              <Controller
                name={item.name}
                control={control}
                render={({ field }) => (
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={field.value || false}
                      onClick={(e) => field.onChange(!field.value)}
                      style={{ marginRight: "10px", transform: "scale(1.2)" }}
                    />
                    <Typography variant="body1">{item.label}</Typography>
                  </label>
                )}
              />
            </Grid>
          ))}

          {/* Other No CPAP Reason */}
          <Grid item xs={12}>
            <Controller
              name="other_NoCPAP"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Other (please specify)"
                  size="small"
                  fullWidth
                  variant="outlined"
                  {...field}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Treatment Preference Statement */}
        <Grid container spacing={3} sx={{m: 2, p: 2, backgroundColor: "#e8f4fd", borderRadius: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
              Because of my inability to use a CPAP device, I wish to have an alternative method of treatment. I would like to try an oral appliance in an attempt to control my snoring and obstructive sleep apnea.
            </Typography>
          </Grid>
        </Grid>

        {/* Signature Section */}
        <Grid container spacing={3} sx={{m: 2, p: 2, backgroundColor: "#f8f9fa", borderRadius: 2 }}>
          <Grid item xs={12} md={6}>
            <Controller
              name="patientSignature"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Patient's Signature"
                  size="small"
                  fullWidth
                  variant="outlined"
                  {...field}
                />
              )}
            />
            <Typography variant="caption" color="textSecondary" align="center" sx={{ mt: 1 }}>
              Patient's Signature
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Controller
              name="signatureDate"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Date"
                  type="date"
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  {...field}
                  value={signatureDate || ""}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    setSignatureDate(e.target.value);
                  }}
                />
              )}
            />
            <Typography variant="caption" color="textSecondary" align="center" sx={{ mt: 1 }}>
              Date
            </Typography>
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            sx={{
              backgroundColor: "#A574FD",
              color: "white",
              minWidth: 120,
              height: 40,
              "&:hover": {
                backgroundColor: "#8A5CE6",
              },
            }}
          >
            {submitting ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </form>
    </Container>
  );
};

export default AffidavitForm;